import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../config/config";
import { getToken } from "../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/external-charge/`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
      headers.set("ngrok-skip-browser-warning", "true");
    }
    return headers;
  },
});

export const externalChargeSlice = createApi({
  reducerPath: "externalChargeSlice",
  baseQuery,
  tagTypes: ["externalCharge"],
  endpoints: (builder) => ({
    createExternalCharge: builder.mutation({
      query: (data) => ({ url: "create", method: "POST", body: data }),
      invalidatesTags: ["externalCharge"],
    }),

    verifyExternalCharge: builder.mutation({
      query: (data) => ({ url: "verify", method: "POST", body: data }),
      invalidatesTags: ["externalCharge"],
    }),

    getExternalCharges: builder.query({
      query: ({ page, limit, status, from_date, to_date } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (status) params.append("status", status);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);
        return `?${params.toString()}`;
      },
      providesTags: ["externalCharge"],
    }),

    getExternalChargeById: builder.query({
      query: (id) => `${id}`,
      providesTags: ["externalCharge"],
    }),

    deleteExternalCharge: builder.mutation({
      query: (id) => ({ url: `${id}`, method: "DELETE" }),
      invalidatesTags: ["externalCharge"],
    }),
  }),
});

export const {
  useCreateExternalChargeMutation,
  useVerifyExternalChargeMutation,
  useGetExternalChargesQuery,
  useGetExternalChargeByIdQuery,
  useDeleteExternalChargeMutation,
} = externalChargeSlice;
